
(function () {
  function hasMeaningfulContent(container) {
    if (!container) return false;

    const copy = container.cloneNode(true);

    // Remove CSS, scripts, comments' containers, and templates.
    copy.querySelectorAll(
      'style, script, template, noscript'
    ).forEach(function (element) {
      element.remove();
    });

    // Remove disabled or empty links/buttons.
    copy.querySelectorAll(
      'a[aria-disabled="true"], button[disabled], [hidden]'
    ).forEach(function (element) {
      element.remove();
    });

    // Ignore whitespace and non-breaking spaces.
    const text = (copy.textContent || '')
      .replace(/\u00a0/g, ' ')
      .trim();

    if (text.length > 0) return true;

    // A real image or media element counts as content.
    const media = copy.querySelector(
      'img[src]:not([src=""]), video, iframe, audio, object, embed'
    );

    if (media) return true;

    // Only count links that have a meaningful destination.
    const links = copy.querySelectorAll('a[href]');

    for (const link of links) {
      const href = (link.getAttribute('href') || '').trim();

      if (
        href &&
        href !== '#' &&
        !href.toLowerCase().startsWith('javascript:')
      ) {
        return true;
      }
    }

    return false;
  }

  function updateAccordions() {
    document.querySelectorAll(
      'details[data-testid="accordion-details"]'
    ).forEach(function (row) {
      const content = row.querySelector('.details-content');

      if (!content) return;

      const shouldHide = !hasMeaningfulContent(content);

      row.hidden = shouldHide;
      row.classList.toggle('accordion-auto-hidden', shouldHide);
    });
  }

  function init() {
    updateAccordions();

    const observer = new MutationObserver(function () {
      updateAccordions();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
 